export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["من"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إلى"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المبلغ"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تحويل"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["التحويل بين الحسابات الخاصة"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["التحويلات داخل المحفظة"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يجب أن تكون حسابات المرسل والمستلم مختلفة"])}
}